import { render, staticRenderFns } from "./TravellersPanel.vue?vue&type=template&id=0d5260b8"
import script from "./TravellersPanel.vue?vue&type=script&lang=js"
export * from "./TravellersPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports